import React, { useState } from 'react';
import useMetaTags from '../hooks/useMetaTags';
import useStructuredData from '../hooks/useStructuredData';
import { NavbarHTAG } from '../components/NavbarHTAG';
import { HeroSectionHTAG } from '../components/HeroSectionHTAG';
import { ServicesHTAG } from '../components/ServicesHTAG';
import { DigitalAssistanceSection } from '../components/DigitalAssistanceSection';
import { AIAutomationSection } from '../components/AIAutomationSection';
import { ProofSectionHTAG } from '../components/ProofSectionHTAG';
import { ProcessSectionHTAG } from '../components/ProcessSectionHTAG';
import { PortfolioSectionHTAG } from '../components/PortfolioSectionHTAG';
import { CreativesPortfolioSection } from '../components/CreativesPortfolioSection';
import { FAQSectionHTAG } from '../components/FAQSectionHTAG';
import { AboutSectionHTAG } from '../components/AboutSectionHTAG';
import { CTASectionHTAG } from '../components/CTASectionHTAG';
import { ContactFormModal } from '../components/ContactFormModal';
import { FooterHTAG } from '../components/FooterHTAG';

export const HTAGLandingPage = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  // Meta tags
  useMetaTags({
    title: 'HTAG Facility | Solutions numériques pour professionnels',
    description: 'HTAG Facility : IA, automatisations n8n, assistance numérique, design web et coaching digital pour PME, associations et indépendants. Solutions intelligentes en Ardennes, Château-Porcien.',
    keywords: 'IA, intelligence artificielle, n8n automatisations, assistance numérique, design web, dépannage informatique, coaching digital, Ardennes, Château-Porcien, PME, professionnels',
    url: 'https://htagfacility.fr',
    image: 'https://htagfacility.fr/og-image.png',
    type: 'website'
  });

  // Structured Data - Organization
  useStructuredData({
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    'name': 'HTAG Facility',
    'description': 'IA, automatisations n8n et assistance numérique complète pour PME, associations et collectivités en Ardennes',
    'image': 'https://htagfacility.fr/logo.png',
    'telephone': '+33XXXXXXXXX',
    'email': 'contact@htagfacility.fr',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'Château-Porcien',
      'addressLocality': 'Château-Porcien',
      'addressRegion': 'Ardennes (08)',
      'postalCode': '08320',
      'addressCountry': 'FR'
    },
    'areaServed': ['FR-08', 'Ardennes', 'Grand Est'],
    'sameAs': [
      'https://www.facebook.com/htagfacility',
      'https://www.linkedin.com/company/htagfacility'
    ],
    'serviceType': [
      'Assistance numérique',
      'Intelligence Artificielle',
      'Automatisations n8n',
      'Design web',
      'Dépannage informatique',
      'Coaching digital',
      'Support IT'
    ]
  });


  return (
    <div className="bg-[#181C25] text-white overflow-hidden min-h-screen lg:ml-16">
      <NavbarHTAG />
      <ContactFormModal isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
      
      <main>
        <section id="accueil">
          <HeroSectionHTAG onContactClick={() => setIsContactFormOpen(true)} />
        </section>
        
        <section id="assistance">
          <DigitalAssistanceSection />
        </section>

        <section id="ia-automation">
          <AIAutomationSection />
        </section>
        
        <section id="services">
          <ServicesHTAG />
        </section>

        <section id="proof">
          <ProofSectionHTAG />
        </section>

        <section id="process">
          <ProcessSectionHTAG />
        </section>

        <section id="portfolio">
          <PortfolioSectionHTAG />
        </section>

        <section id="creatives">
          <CreativesPortfolioSection />
        </section>
        
        <section id="apropos">
          <AboutSectionHTAG />
        </section>
        
        <section id="faq">
          <FAQSectionHTAG />
        </section>
        
        <section id="contact">
          <CTASectionHTAG onContactClick={() => setIsContactFormOpen(true)} />
        </section>
      </main>
      
      <FooterHTAG />
    </div>
  );
};

export default HTAGLandingPage;
